module.exports = {
  eng: 'English',
  no: 'Norwegian',
  error404: 'The page you are looking for does not exist!',
  invalid: 'Invalid',
  name: 'Name',
  phone: 'Phone',
  status: 'Status',
  type: 'Type',
  all: 'All',
  none: 'None',
  allNone: 'All/None',
  date: 'Date',
};
